export default __webpack_public_path__ + "static/media/HASSAN_NL_EPILOG1.da4b94bd.mp3";